<woo-modal-layout size="medium" (close)="close()">
  <h3 header>Stoppa pågående kampanj</h3>
  <p>Initialt ordervärde: {{initialOrderValue() | currency:"SEK": 'symbol': "1.0-0"}}</p>
  <form [formGroup]="form" (submit)="submit.emit({ newOrderValue: form.controls.newOrderValue.value, comment: form.controls.comment.value })">
    <div class="input__container">
      <label for="newOrderValue">Nytt ordervärde</label>
      <input id="newOrderValue" type="text" formControlName="newOrderValue" [wooNumberFormatter]="{ allowEmpty: false, allowDecimals: true }"/>
      @if(form.controls.newOrderValue.invalid && form.dirty) {
        <p class="text--danger text--small">{{form.controls.newOrderValue.errors.invalidOrderValue}}</p>
      }
    </div>
    <div class="input__container">
      <label for="comment">Stoppmeddelande</label>
      <textarea id="comment" type="text" formControlName="comment"></textarea>
      @if(form.controls.comment.invalid && form.dirty) {
        <p class="text--danger text--small">{{form.controls.comment.errors.invalidComment}}</p>
      }
    </div>
    <button class="button primary-1" type="submit" [disabled]="!form.valid" e2e-id="confirm">Stoppa kampanj</button>
    <button class="link primary-1" (click)="close()" type="button">Avbryt</button>
  </form>
</woo-modal-layout>
